import axios from 'axios'

const StudentResidenceService = {
  async getList (params = {}) {
    return axios.get('admin/student-residences', { params })
  },

  async show (id) {
    return axios.get(`admin/student-residences/${id}`)
  },

  async store (data) {
    return axios.post('admin/student-residences', data)
  },

  async update (id, data) {
    return axios.put(`admin/student-residences/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/student-residences/${id}`)
  }
}

export default StudentResidenceService
